import { useTranslation } from 'react-i18next';

export default function WhyChooseSection() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-translate-2',
      title: t('feature_interpreter'),
      description: t('feature_interpreter_desc'),
    },
    {
      icon: 'ri-passport-line',
      title: t('feature_visa'),
      description: t('feature_visa_desc'),
    },
    {
      icon: 'ri-hotel-line',
      title: t('feature_accommodation'),
      description: t('feature_accommodation_desc'),
    },
    {
      icon: 'ri-video-chat-line',
      title: t('feature_consultation'),
      description: t('feature_consultation_desc'),
    },
    {
      icon: 'ri-24-hours-line',
      title: t('feature_support'),
      description: t('feature_support_desc'),
    },
    {
      icon: 'ri-gift-line',
      title: t('feature_package'),
      description: t('feature_package_desc'),
    },
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('why_choose_title')}
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            {t('why_choose_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center p-6 rounded-lg hover:bg-gradient-to-br hover:from-teal-50 hover:to-cyan-50 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}